//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation } from "@/mixins/index";
import Events from "./mixins/Events";
export default {
  name: "systemEvents",
  mixins: [serchSelect, tabulation, Events],
  data: function data() {
    return {
      // more:true,
      value2: [],
      searchData: {
        begin_date: '',
        end_date: '',
        country: '',
        begin_action: 'activity',
        retain_action: 'create_role',
        retain_days: 5,
        analyze_type: 'device',
        ad_id: ''
      },
      behaviorList: [{
        label: this.$t('activity'),
        value: 'activity',
        disabled: false
      }, {
        label: this.$t('createRole'),
        value: 'create_role',
        disabled: false
      }, {
        label: this.$t('register'),
        value: 'register',
        disabled: false
      }, {
        label: this.$t('loginLabel'),
        value: 'login',
        disabled: false
      }, {
        label: this.$t('rechargeLabel'),
        value: 'recharge',
        disabled: false
      }],
      rehaviorList: [{
        label: this.$t('activity'),
        value: 'activity',
        disabled: true
      }, {
        label: this.$t('createRole'),
        value: 'create_role',
        disabled: false
      }, {
        label: this.$t('register'),
        value: 'register',
        disabled: false
      }, {
        label: this.$t('loginLabel'),
        value: 'login',
        disabled: false
      }, {
        label: this.$t('rechargeLabel'),
        value: 'recharge',
        disabled: false
      }]
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {}
};